module.exports = __webpack_public_path__ + "assets/img/android-chrome-192x192.c30163da.png";